import { render, staticRenderFns } from "./IconDeliveryPrice.vue?vue&type=template&id=a319ec9c"
import script from "./IconDeliveryPrice.vue?vue&type=script&lang=js"
export * from "./IconDeliveryPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports